var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25639 14.7692C1.98437 14.7692 1.7235 14.6612 1.53115 14.4688C1.33881 14.2765 1.23075 14.0156 1.23075 13.7436V2.25641C1.23075 1.98439 1.33881 1.72352 1.53115 1.53117C1.7235 1.33883 1.98438 1.23077 2.25639 1.23077H5.53844C5.87831 1.23077 6.15383 0.955251 6.15383 0.615384C6.15383 0.275516 5.87831 0 5.53844 0H2.25639C1.65795 0 1.08403 0.237728 0.660868 0.660887C0.237709 1.08405 -1.90735e-05 1.65797 -1.90735e-05 2.25641V13.7436C-1.90735e-05 14.342 0.237709 14.916 0.660868 15.3391C1.08403 15.7623 1.65795 16 2.25639 16H5.53844C5.87831 16 6.15383 15.7245 6.15383 15.3846C6.15383 15.0447 5.87831 14.7692 5.53844 14.7692H2.25639ZM10.8467 12.5377C11.087 12.778 11.4767 12.778 11.717 12.5377L15.8112 8.44356C15.9276 8.3316 16 8.17425 16 7.99999C16 7.82532 15.9272 7.66764 15.8103 7.55563L11.717 3.4623C11.4767 3.22198 11.087 3.22198 10.8467 3.4623C10.6064 3.70263 10.6064 4.09226 10.8467 4.33259L13.8987 7.38461H5.53846C5.19859 7.38461 4.92308 7.66012 4.92308 7.99999C4.92308 8.33986 5.19859 8.61538 5.53846 8.61538H13.8988L10.8467 11.6674C10.6064 11.9078 10.6064 12.2974 10.8467 12.5377Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExit);
export default __webpack_public_path__ + "static/media/icn-exit.9a25e2e0.svg";
export { ForwardRef as ReactComponent };